import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl bg-opacity-80 bg-blue-200" }, "Publication Details", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "text-left p-5" }
const _hoisted_5 = { class: "text-2xl" }
const _hoisted_6 = { class: "text-xl" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" DOI: ")
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "grid grid-cols-2 gap-4 p-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "text-l bg-opacity-40 bg-blue-200" }, "Reused by", -1)
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "w-min" }, "DOI"),
  /*#__PURE__*/_createElementVNode("th", null, "Title")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "text-l bg-opacity-40 bg-blue-200" }, "Reusing", -1)
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Identifier"),
  /*#__PURE__*/_createElementVNode("th", null, "Title")
], -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", null, "Loading data for " + _toDisplayString(_ctx.doi) + " ...", 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.paper.message.title.join(": ")) + " " + _toDisplayString(_ctx.paper.message.subtitle.length > 0 ? ": " + _ctx.paper.message.subtitle.join(" ") : ""), 1),
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.paper.message.author.map((a) => `${a.given} ${a.family}`).join(", ")), 1),
            _createElementVNode("p", null, [
              _hoisted_7,
              _createElementVNode("a", {
                href: 'https://doi.org/' + _ctx.paper.message.dOI
              }, _toDisplayString(_ctx.paper.message.dOI), 9, _hoisted_8)
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.paper.message.containerTitle.join(", ")), 1),
            _createElementVNode("p", null, " Published: " + _toDisplayString(_ctx.paper.message.created.dateTime.toLocaleDateString()), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("table", _hoisted_11, [
                _hoisted_12,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reusedStuff, (r, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_router_link, {
                        class: "hover:bg-blue-50",
                        to: {
                    name: 'paper',
                    params: {
                      doiPrefix: r.doi.split('/')[0],
                      doiSuffix: r.doi.split('/')[1],
                    },
                  }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(r.doi), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(r.doiDetails.title.join(": ")), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_13,
              _createElementVNode("table", _hoisted_14, [
                _hoisted_15,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reusingStuff, (r, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      (r.doi)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                            _createVNode(_component_router_link, {
                              class: "hover:bg-blue-50",
                              to: {
                            name: 'paper',
                            params: {
                            doiPrefix: r.doi.split('/')[0],
                            doiSuffix: r.doi.split('/')[1],
                            },
                        }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(r.doi), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : (r.alternativeId.startsWith('arxiv:'))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, " ARXIV " + _toDisplayString(r.alternativeId), 1))
                          : (r.alternativeId.startsWith('https://github.com'))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, " GITHUB " + _toDisplayString(r.alternativeId), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(r.alternativeId), 1))
                    ]),
                    _createElementVNode("td", null, _toDisplayString(r.doiDetails ? r.doiDetails.title.join(": ") : ""), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
  ]))
}